export default __webpack_public_path__ + "static/banner-1-24f174574c671bad8637200b0144d0de.png";